import dynamic from 'next/dynamic'

export const Announcement = dynamic(() => import('./announcement'))
